import { Fragment } from "react";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { reduce } from "et3-type-guards";
import { fontWeights } from "et3-ui-library";

import i18n from "../../../../constants/i18n";
import getCorePopUpStore from "../../../../stores/core/core-popup-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getKhattabatMatchingStore from "../../../../stores/khattabat-stores/matching-stores";

const MatchesFoundCount = withLiteObserverAndTheme(() => {
  const resultsNumber = reduce(
    () => getKhattabatMatchingStore().matchesIds.get().length,
    0
  );

  const selectedMatchesCount = reduce(
    () => getKhattabatMatchingStore().selectedMatchesCount.get(),
    0
  );

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 1, sm: 4 }}
        alignItems={{ xs: "flex-start", sm: "center" }}
      >
        <Typography variant="body1">
          {`${i18n.get("RESULTS_NUMBER")}: `}
          <Typography component="span" fontWeight={fontWeights.semibold}>
            {resultsNumber}
          </Typography>
        </Typography>
        {resultsNumber > 0 && (
          <Fragment>
            <Typography variant="body1">
              {`${i18n.get("KHATTABAT_SELECTED_MATCHES")}: `}
              <Typography component="span" fontWeight={fontWeights.semibold}>
                {selectedMatchesCount}
              </Typography>
            </Typography>
            <Button
              variant="contained"
              onClick={() =>
                getCorePopUpStore().openConfirmationPopUps(
                  "KHATTABAT_MATCHING_RESULTS_POPUP"
                )
              }
            >
              {i18n.get("KHATTABAT_SHOW_RESULTS")}
            </Button>
          </Fragment>
        )}
      </Stack>
    </Paper>
  );
});

export default MatchesFoundCount;
